export default __webpack_public_path__ + "static/media/1.fff86b53.jpg";